import React, { useEffect, useState, useRef } from "react";
import Header from "../../../Componets/Header";
import Table from "../../../Componets/Table";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { get_all_received } from "../../../Controllers/Inventory/Received";
import moment from "moment";
import Loadercomponent from "../../../Componets/Loader";
import ReactToPrint from "react-to-print";
import { Button } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import Status from "../../../Componets/Status";
import DotIcon from "../../../Assets/Svg/dot";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { registerCairoFont } from "../cairo-font";
import formatDateDDMMYYYY from "../../../Main/formatDate";


const ReceivedOrdersReport = () => {
  let location = useLocation();
  let componentRef = useRef();

  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState([]);
  const [summaryData, setSummaryData] = useState({
    totalOrders: 0,
    totalAmount: 0,
    completedOrders: 0,
    pendingOrders: 0
  });

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 0,
    totalCount: 0
  });

  const headers = {
    name: "Received Orders",
    components: [
      {
        type: "search",
        name: "search",
        placeholder: "Search by order number",
        value: "",
      },
      {
        type: "select",
        name: "sort",
        placeholder: "Sort",
        value: null,
        allowClear: true,
        options: [
          { value: "0", label: "Total Amount (Low to High)" },
          { value: "1", label: "Total Amount (High to Low)" },
        ],
      },
      /*   {
          type: "filter",
          name: "supplier",
          placeholder: "Supplier",
          allowClear: true,
          showSearch: true,
          filterOption: false,
          api: "get-all-suppliers",
          value: null,
          options: null,
        }, */
      /* {
        type: "filter",
        name: "status",
        placeholder: "Status",
        value: null,
        allowClear: true,
        options: [
          { value: 0, label: "Pending" },
          { value: 1, label: "Completed" },
        ],
      }, */
      {
        type: "range",
        name: "date",
        value: {
          start: "",
          end: "",
        },
      },
    ],
    navigate: {
      tabs: [
        {
          name: "Reports",
          path: "/app/reports",
        },
        {
          name: "Received Order",
          path: ""
        }
      ],
      total: [
        { value: 0, label: "Total" },
        { value: 0, label: "Active" },
        { value: "0", label: "Inactive" },
      ],
    },
  };

  const tables =
    [
      { name: "Order Number", key: "Number" },
      { name: "Supplier", key: "Supplier" },
      { name: "Order Date", key: "OrderDate" },
      { name: "Due Date", key: "DueDate" },
      { name: "Subtotal", key: "Subtotal" },
      { name: "Tax", key: "Tax" },
      { name: "Discount", key: "Discount" },
      { name: "Delivery", key: "Delivery" },
      { name: "Total", key: "Total" },
      { name: "Transfer Status", key: "Transfer Status" },
    ]


  const [header, setHeader] = useState(headers);

  const paginationdata = (data) => {
    let headerdata = {};

    header?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      supplier: headerdata?.supplier,
      status: headerdata?.status,
      date: headerdata?.date,
    });
  };

  const formdata = (data) => {
    let page = data?.search ? pagination?.currentPage : 1;

    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const fetchData = async (tabledata = {}) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        supplier: tabledata?.supplier,
        status: tabledata?.status,
        date: tabledata?.date,
        page: tabledata?.currentPage || 1,
        limit: 10,
        source: "ReceivedOrdersReport"
      };

      const receivedOrders = await get_all_received(data);

      if (receivedOrders?.status) {
        const tableData = receivedOrders?.data?.data?.map((order) => ({
          "Order Number": `#RO-${order?.number}`,
          Supplier: order?.branch?.name || 'N/A',
          "Order Date": formatDateDDMMYYYY(order?.date),
          "Due Date": order?.due_date ? formatDateDDMMYYYY(order?.due_date) : 'N/A',
          Subtotal: parseFloat(order?.subtotal || 0)?.toFixed(3),
          Tax: parseFloat(order?.taxamount || 0)?.toFixed(3),
          Discount: parseFloat(order?.discount || 0)?.toFixed(3),
          Delivery: parseFloat(order?.delivery || 0)?.toFixed(3),
          Total: parseFloat(order?.total || 0)?.toFixed(3),
          "Transfer Status": order?.received ? (
            <div className="flex">
              <div className={`my-auto pr-2 text-green-500`}>
                <DotIcon width={10} height={10} />
              </div>
              <div>Accepted</div>
            </div>
          ) : (
            <div className="flex">
              <div className={`my-auto pr-2 text-red-500`}>
                <DotIcon width={10} height={10} />
              </div>
              <div>Not-accepted</div>
            </div>
          ),
        })) || [];

        setBody(tableData);

        const orders = receivedOrders?.data?.data || [];

        setSummaryData({
          totalOrders: receivedOrders?.data?.totalCount || 0,
          totalAmount: receivedOrders?.data?.summary?.total_amount || 0,
          completedOrders: receivedOrders?.data?.summary?.received || 0,
          pendingOrders: receivedOrders?.data?.summary?.not_received || 0
        });

        setPagination({
          currentPage: receivedOrders?.data?.currentPage || 1,
          totalPages: receivedOrders?.data?.totalPages || 0,
          totalCount: receivedOrders?.data?.totalCount || 0
        });

        setLoader(false);
      } else {
        toast?.error(receivedOrders?.message || "Failed to fetch received orders");
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
      setLoader(false);
    }
  };

  const headerReset = () => {
    let componentData = [];
    headers?.components?.map((value, index) => {
      componentData?.push({
        ...value,
        value: null,
      });
    });
    setHeader({ ...headers, components: componentData });
  };

  useEffect(() => {
    fetchData();
    headerReset();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB");
  };

  const downloadCSV = () => {
    console.log("Download CSV clicked");

    if (!body || body.length === 0) {
      console.log("No data available for download");
      toast.error("No data available to download");
      return;
    }

    try {
      const header = ["Order", "Suplier", "Order Date", "Due Date", "Subtotal", "Tax", "Discount", "Delivery", "Tax", "Transfer Status"];

      const rows = body?.map((item) => {
        const row = [
          item?.["Order Number"] ? `#RO-${item["Order Number"]}` : "-",
          item?.Supplier || "-",
          item?.["Order Date"] || "-",
          item?.["Due Date"] || "-",
          item?.Subtotal || 0,
          item?.Tax || 0,
          item?.Discount || 0,
          item?.Delivery || 0,
          item?.Total || 0,
          (typeof item?.["Transfer Status"]?.props?.children?.[1]?.props?.children === "string"
            ? item["Transfer Status"].props.children[1].props.children
            : "-"),
        ];
        return row;
      });

      const csvContent = [header, ...rows]
        .map(row => row.map(field => `"${field}"`).join(","))
        .join("\n");

      const encoder = new TextEncoder();
      const encodedContent = encoder.encode('\uFEFF' + csvContent);

      const blob = new Blob([encodedContent], { type: 'text/csv;charset=utf-8' });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);

      link.setAttribute("href", url);
      link.setAttribute("download", `Received_Orders_Report_${new Date().toLocaleDateString().replace(/\//g, '_')}.csv`);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Error generating CSV:", error);
      toast.error("Failed to generate CSV file");
    }
  };

  const downloadPDF = () => {
    if (!body || body.length === 0) return;

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });
    registerCairoFont(doc)
    const pageWidth = doc.internal.pageSize.getWidth();

    doc.setFont("Cairo-Bold", "bold");

    doc.setFontSize(18);
    doc.text("Received Orders Report", pageWidth / 2, 18, { align: "center" });

    const now = new Date();
    const formattedDate = now.toLocaleDateString("en-GB");
    const formattedTime = now.toLocaleTimeString();
    doc.setFontSize(10);
    doc.text(`Downloaded on: ${formattedDate} ${formattedTime}`, pageWidth / 2, 26, { align: "center" });

    const tableRows = body?.map((item, index) => [
      item?.["Order Number"] ? `#RO-${item["Order Number"]}` : "-",
      item?.Supplier || "-",
      item?.["Order Date"] || "-",
      item?.["Due Date"] || "-",
      item?.Subtotal || 0,
      item?.Tax || 0,
      item?.Discount || 0,
      item?.Delivery || 0,
      item?.Total || 0,
      (typeof item?.["Transfer Status"]?.props?.children?.[1]?.props?.children === "string"
        ? item["Transfer Status"].props.children[1].props.children
        : "-"),
    ]);

    autoTable(doc, {
      startY: 32,
      head: [["Order", "Suplier", "Order Date", "Due Date", "Subtotal", "Tax", "Discount", "Delivery", "Tax", "Transfer Status"]],
      body: tableRows,
      styles: {
        font: "Cairo",
        textColor: [0, 0, 0],
        lineColor: [222, 222, 222],
        lineWidth: 0.2
      },
      headStyles: {
        font: "Cairo",
        fontStyle: "bold",
        fillColor: false,
        lineColor: [222, 222, 222],
        lineWidth: 0.2
      },
    });

    doc.autoPrint();

    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);

    window.open(pdfUrl);
  };

  const CustomTableFooter = () => (
    <div className="mt-6">
      <div className="grid grid-cols-4 gap-4 mb-6">
        <div className="bg-white p-4 rounded-md border">
          <div className="text-sm text-gray-600">Total Orders</div>
          <div className="text-2xl font-bold">{summaryData.totalOrders}</div>
        </div>
        <div className="bg-white p-4 rounded-md border">
          <div className="text-sm text-gray-600">Total Amount</div>
          <div className="text-2xl font-bold">
            {summaryData.totalAmount?.toFixed(3)}
          </div>
        </div>
        <div className="bg-white p-4 rounded-md border">
          <div className="text-sm text-gray-600">Completed Orders</div>
          <div className="text-2xl font-bold">
            {summaryData.completedOrders}
          </div>
        </div>
        <div className="bg-white p-4 rounded-md border">
          <div className="text-sm text-gray-600">Pending Orders</div>
          <div className="text-2xl font-bold">
            {summaryData.pendingOrders}
          </div>
        </div>
      </div>

      <div className="text-right pb-4 flex gap-3 justify-end mt-4">
        <Button
          className="mr-2  !bg-[#07b553] !border-[#07b553] hover:!bg-[#38cb82] hover:!border-[#38cb82]"
          type="primary"
          onClick={downloadCSV}
        >
          Download CSV
        </Button>

        <Button
          className="mr-2  !bg-[#07b553] !border-[#07b553] hover:!bg-[#38cb82] hover:!border-[#38cb82]"
          type="primary"
          onClick={downloadPDF}
        >
          Download PDF
        </Button>
      </div>
    </div>
  );

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <CustomTableFooter />
        <Table
          head={tables}
          body={body}
          pagination={pagination}
          paginationdata={paginationdata}
          summary={2}
        />
      </Loadercomponent>
    </Header>
  );
};

export default ReceivedOrdersReport;